import { createTheme, ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';

// Supporting color sampled from the Enantio logo
const primaryColor = '#428585';

// Create the dark theme instance
const darkTheme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: primaryColor,
    },
    secondary: {
      main: '#b0bec5', // A light grey for contrast
    },
    background: {
      default: '#212121', // Dark grey for the main background
      paper: '#333333',   // Slightly lighter for surfaces like the sidebar and message bubbles
    },
    text: {
      primary: '#ffffff',
      secondary: '#b0bec5',
    },
  },
  typography: {
    fontFamily: 'Roboto, -apple-system, BlinkMacSystemFont, "Segoe UI", "Helvetica Neue", Arial, sans-serif',
  },
});

interface MuiThemeProviderProps {
    children: React.ReactNode;
}

// Create a ThemeProvider component to wrap our app
export const MuiThemeProvider: React.FC<MuiThemeProviderProps> = ({ children }) => {
  return (
    <ThemeProvider theme={darkTheme}>
      <CssBaseline />
      {children}
    </ThemeProvider>
  );
};